import { EuiSpacer } from '@elastic/eui';
import TableFeatures from 'components/Outdoor_Cameras/IN-9008_HD/Product_Features/TableFeatures';
import NavButtons from 'components/Outdoor_Cameras/IN-9008_HD/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  TableFeatures,
  NavButtons,
  BreadCrumbs,
  SEOHelmet,
  React
};